import { render, staticRenderFns } from "./NavComps.vue?vue&type=template&id=f1b4e50e&scoped=true"
import script from "./NavComps.vue?vue&type=script&lang=js"
export * from "./NavComps.vue?vue&type=script&lang=js"
import style0 from "./NavComps.vue?vue&type=style&index=0&id=f1b4e50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b4e50e",
  null
  
)

export default component.exports